import { Component, OnInit,ElementRef,ViewChild,NgZone,EventEmitter,HostListener} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { HelperService } from '../helper.service';
import { Http, Response,Headers } from '@angular/http';
import { Subject } from 'rxjs/Subject';
import { DataTableDirective } from 'angular-datatables';
import {MatSnackBar} from '@angular/material';
import { NgForm } from '@angular/forms';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
// import { MatGoogleMapsAutocompleteModule } from '@angular-material-extensions/google-maps-autocomplete';
import {Observable} from 'rxjs';
import {FormControl} from '@angular/forms';
import {startWith, map} from 'rxjs/operators';
import { MatAccordion } from '@angular/material';
import {CookieService} from 'angular2-cookie/core';
import {SnackbarComponent} from '../snackbar/snackbar.component';
// import { HttpHeaders} from '@angular/common/http';
// import { MapsAPILoader } from '@agm/core';
// declare var google: any;
class Data {
  id: number=0;
  username: string='';

}
@Component({
  selector: 'app-parents',
  templateUrl: './parents.component.html',
  styleUrls: ['./parents.component.css'],
  providers: [HelperService] 
})
export class ParentsComponent implements OnInit {
    // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }
  @ViewChild('autoSearch') public searchElement: ElementRef;
  @ViewChild(MatAccordion) accordion: MatAccordion;
  dtOptions: DataTables.Settings = {order:[]};
  dtTrigger: Subject<any> = new Subject();
  datas: Data[] = [];
  dtElement: DataTableDirective;

  list=true;
  edit=false;
  add=false;
  view=false;
  icon=this.helper.add_icon;
  subscriptions;
  icon_action='addClick';
  syllabus_list;
  selected_subscription_id=[];
  grade_list;
  subject_list;
  sgid;
  syllabus_id;
  syllabus_grade_id;
  selected_grade_id:any=[];
  selected_syllabus_id:any=[];
  parent_email;
  parent_id;
  student_username;
  student_email;
  student_id;
  student_list:any=[];
  selected_grade;
  selected_syllabus;
  selected_subscription;
  start_date;
  start_dates;
  editdob;
  editdobdate;
  student_countrycode;
  student_phone;
  student_city;
  indexedmonth;
  syllabusname;
  gradename;
  packagename;
  notPurchased;
  Purchased;
  doubtscount;
  testsTaken;
  studentid;
  status;
  options: string[] = ['One', 'Two', 'Three'];
  streets: string[] = ['Champs-Élysées', 'Lombard Street', 'Abbey Road', 'Fifth Avenue'];
  filteredStreets: Observable<string[]>;
  control = new FormControl();
  public searchControl: FormControl;
  @ViewChild("search")
  public searchElementRef: ElementRef;
  public latitude: number;
  public longitude: number;
  todayDate:Date = new Date("1950-01-01");
  tomorrow = new Date(); 
  indexedate;
  student_registered;
  chatcount;
  user_permissions:any=[];
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  constructor(private http:Http, private helper:HelperService,private snackbar: MatSnackBar,private router: Router  , private ngZone : NgZone,private activatedRouter:ActivatedRoute,private cookie:CookieService) {
    
    // const headers = new HttpHeaders()
    // .append('Content-Type', 'application/json')
    // .append('Access-Control-Allow-Headers', 'Content-Type')
    // .append('Access-Control-Allow-Methods', 'GET')
    // .append('Access-Control-Allow-Origin', '*');
    this.tomorrow.setDate(this.tomorrow.getDate());


    activatedRouter.queryParams.subscribe(params => {
      if(params['id'])
      {
        let id = params['id'];

        this.http.get(this.helper.base_url+'http/get/parentDetail/'+id,{ headers: this.headers })
          .map(this.extractData)
          .subscribe(data => {
          
            this.viewClick(data[0]);
            
           
          });
      }
    });
   }

  ngOnInit() {
    this.router.onSameUrlNavigation = 'reload';
    this.http.get(this.helper.base_url+'http/get/parents',{ headers: this.headers })
      .map(this.extractData)
      .subscribe(data => {
      
        this.datas = data;        
        this.dtTrigger.next();
        
       
      });
      this.http.get(this.helper.base_url+'http/get/publishedsyllabus',{ headers: this.headers })
      .map(this.extractData)
      .subscribe(syllabuses => {
       
        this.syllabus_list = syllabuses;
        
      });

      let user=this.cookie.get('user_id');
    this.http.get(this.helper.base_url+'/http/get/user/permissions',{ headers: this.headers })
    
    .subscribe(data => {
      this.user_permissions = JSON.parse(data['_body']);
     //console.log(this.user_permissions);
        
     
    });

      
      
      this.filteredStreets = this.control.valueChanges.pipe(startWith(''),
        map(value => this._filter(value))
      );
      // this.mapsAPILoader.load().then(() => {
      //   let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
      //     types: ["geocode"]
      //   });
      //   autocomplete.addListener("place_changed", () => {
      //     this.ngZone.run(() => {
      //       //get the place result
      //       let place: google.maps.places.PlaceResult = autocomplete.getPlace();
    
      //       //verify result
      //       if (place.geometry === undefined || place.geometry === null) {
      //         return;
      //       }
            
      //       //set latitude, longitude and zoom
      //       this.latitude = place.geometry.location.lat();
      //       this.longitude = place.geometry.location.lng();
      //       //this.zoom = 12;
      //     });
      //   });
      // });
  }
  private _filter(value: string): string[] {
    const filterValue = this._normalizeValue(value);
    return this.streets.filter(street => this._normalizeValue(street).includes(filterValue));
  }
  private _normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, '');
  }
  placeTyped(event)
  {
    //alert(event.data);
    
    let url = 'https://maps.googleapis.com/maps/api/place/autocomplete/json?input='+event.data+'&types=(cities)&key=AIzaSyBtA2W_uxykabFokdqJX3NoZTv7P18kLcg'
    // this.http.request(url,{headers}).map(this.extractData).subscribe(data => {
    //   console.log(data);
    // });
    //const headers = new HttpHeaders()
    // .append('Content-Type', 'application/json')
    // .append('Access-Control-Allow-Headers', 'Content-Type')
    // .append('Access-Control-Allow-Methods', 'GET')
    // .append('Access-Control-Allow-Origin', '*');
    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     'Accept': 'application/x-www-form-urlencoded',
    //     'Content-Type':  'application/json',
    //     'Authorization': 'Basic' + btoa(username + ":" + password)
    //   })
    // };
    $.ajax({
      url: url, 
      type: "GET",   
      dataType: 'jsonp',
      cache: false,
      success: function(response){                          
          //alert(response); 
          console.log(response);                  
      }           
  }); 
  
  // function logResults(json){
  //   console.log(json);
  // }
  
  // $.ajax({
  //   url: url,
  //   dataType: "jsonp",
  //   contentType: 'application/json',
  //   jsonpCallback: "logResults"
  // });
  // fetch(url, {
  //           method: 'GET',
  //           //body: JSON.stringify(data),
  //           mode: 'cors',
            
  //           headers: {
              
  //               'Content-Type': 'application/json',
  //               "Accept": 'application/json',
  //               'dataType': 'jsonp',
  //           }
  //       })
  //   .then((data) => data.json())
  //   .then((resp) => console.log(resp))
  //   .catch((err) => console.log(err))
    // return this.httpHeaders.jsonp(url, 'callback');
  //   let headers = new Headers();

  //   headers.append('Content-Type', 'application/json');
  //   headers.append('Accept', 'application/json');
  //   headers.append('Access-Control-Allow-Origin', '*');
  //   //headers.append('Authorization', 'Basic ' + base64.encode(username + ":" +  password));
  //   headers.append('Origin','https://www.google.co.in/');
  //   fetch(url{
  //     mode: 'cors',
  //     credentials: 'include',
  //     method: 'GET',
  //     headers: headers
  // }).then(function(response) {
  //     return response.json();
  //   }).then(function(data) {
  //     alert("faf");
  //        console.log(data);
       
  //   }).catch(function() {
  //     //console.log("Booo");
  //   });
       
    //   });
  }

  syllabusChange(event:any){
    let syllabus_id=event.target.value;
    this.subject_list=[];
   
    this.http.get(this.helper.base_url+'http/get/publishedgrade/'+syllabus_id,{ headers: this.headers })
      .map(this.extractData)
      .subscribe(data => {
        this.grade_list = data;
         
       
      });

  }
  gradeChange(event:any){

    this.sgid=event.target[event.target.selectedIndex].dataset.sgid;
    
    this.subject_list=[];
    this.http.get(this.helper.base_url+'http/get/subscription/'+this.sgid,{ headers: this.headers })
    .map(this.extractData)
    .subscribe(data => {
      this.subscriptions = data;
      
    });

  }
    studentChange(event:any){

   

  }

  listClick(e){
    this.list=true;
    this.edit=false;
    this.add=false;
    this.view=false;
    this.icon=this.helper.add_icon;
    this.icon_action="addClick";
  }
  addClick(e){
  
    this.list=false;
    this.edit=false;
    this.add=true;
    this.view=false;
    this.icon=this.helper.list_icon;
    
    this.icon_action="listClick";
  }
    editClick(data){
      //alert(data.dob);
    this.parent_email=data.email;
    this.parent_id=data.id;
    // this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
    // this.router.navigate(["student/"+this.parent_id]));
    this.student_username=data.username;
      this.student_id=data.studentid;
     //alert(this.student_id);
      if(data.syllabus_grade.length!=0){
        this.selected_grade=data.syllabus_grade[0].grade_id;
      this.selected_syllabus=data.syllabus_grade[0].syllabus_id;
      }
    this.student_email = data.email;
    //this.selected_subscription_id =data.subscriptions;
    this.syllabus_grade_id=data.syllabus_grade_id;
    this.start_dates = data.dob;
    this.student_countrycode = data.country_code;
    this.student_phone = data.phone;
    this.student_city = data.city;
    this.status = data.status;
this.http.get(this.helper.base_url+'http/get/students/'+this.parent_id,{ headers: this.headers })
     
      .subscribe(data => {
       
        this.student_list = JSON.parse(data['_body']);
       
      });

this.http.get(this.helper.base_url+'http/get/syllabus',{ headers: this.headers })
    .map(this.extractData)
    .subscribe(syllabuses => {
       
      this.syllabus_list = syllabuses;
      this.http.get(this.helper.base_url+'http/get/grade/'+data.syllabus_grade[0].syllabus_id,{ headers: this.headers })
      .map(this.extractData)
      .subscribe(data => {
        this.grade_list = data;
        this.http.get(this.helper.base_url+'http/get/subscription/'+this.syllabus_grade_id,{ headers: this.headers })
        .map(this.extractData)
        .subscribe(data => {
          this.subscriptions = data;    
          
        });
      });
     
    });

    this.list=false;
    this.edit=true;
    this.add=false;
    this.view=false;
    this.icon=this.helper.list_icon;
    this.icon_action="listClick";
//     this.selected_syllabus_id=data.subscription[0].syllabus_id;
//     this.selected_grade_id=data.subscription[0].grade_id;
//     this.syllabus_grade_id=data.subscription[0].syllabus_grade_id;
//     this.selected_subscription_id=data.subscriptions;

// this.http.get(this.helper.base_url+'http/get/students/'+this.parent_id)
     
//       .subscribe(data => {
       
//         this.student_list = JSON.parse(data['_body']);
//         console.log(this.student_list);
//         console.log(this.parent_id);
//       });


// this.http.get(this.helper.base_url+'http/get/syllabus')
//     .map(this.extractData)
//     .subscribe(syllabuses => {
       
//       this.syllabus_list = syllabuses;
//       this.http.get(this.helper.base_url+'http/get/grade/'+this.selected_syllabus_id)
//       .map(this.extractData)
//       .subscribe(data => {
//         this.grade_list = data;
//         this.http.get(this.helper.base_url+'http/get/subscription/'+this.syllabus_grade_id,)
//         .map(this.extractData)
//         .subscribe(data => {
//           this.subscriptions = data;    
          
//         });
//       });
     
//     });



//     this.list=false;
//     this.edit=true;
//     this.add=false;
//     this.icon=this.helper.list_icon;
//     this.icon_action="listClick";
   
  
  }
  viewClick(data)
  {
    //console.log(data);
    this.parent_id = data.id;
    this.student_id = data.studentid;
    this.student_username =  data.username;
    this.parent_email=data.email;
    this.start_dates = data.dob;
    this.student_phone = data.country_code+" "+data.phone;
    this.syllabusname = data.syllabusname;
    this.gradename    = data.gradename;
    this.packagename = data.packagename;
    this.notPurchased = data.getNotPurchased;
    this.student_city        = data.city;
    this.doubtscount     = data.doubtscount;
    this.testsTaken     = data.testsTaken;
    this.Purchased     = data.getPurchased;
    this.studentid =  data.studentid;
    this.student_registered = data.currentdate;
    this.chatcount = data.getChats;
    //this.doubtscount     = data.doubtscount;

    this.list=false;
    this.edit=false;
    this.add=false;
    this.view=true;
    this.icon=this.helper.list_icon;
    this.icon_action="listClick";
    
  } 
  private extractData(res: Response) {
    const body = res.json();
    return body.data || {};
  }
  delete_form(id){
          
    let snackBarRef = this.snackbar.openFromComponent(SnackbarComponent, {
    //this.snackbar.open('Are you Sure!','Delete', {
      duration: 3000,
      extraClasses:  ['warning-snackbar'],
    });
    // .onAction().subscribe(() => {
    //   //alert("ondelete");
    //   this.http.get(this.helper.base_url+'http/delete/parent/'+id,)
    //   .subscribe(
         
    //       (data) => {
    //         let body = JSON.parse(data['_body']);
    //         //console.log(body)
    //         if(body.success == 1)
    //         {
    //           this.listClick(null) ;
    //           this.refresh(false,body.message) ;
    //         }
    //         else
    //         {
    //           this.snackbar.open(body.message, null, {
    //             duration:5000,
    //               extraClasses:'error-snackbar',
    //               verticalPosition:'top'
    //             });
    //         }
    //         //this.refresh(false,'Parent deleted Successfully')
    //       }, //For Success Response
    //       err => {console.error(err)} //For Error Response
    //   ); 
    // });

    // snackBarRef.afterDismissed().subscribe( data => {
    //   alert("dismissed");
    //   console.log('after close data :', data);
    //   // handle your code working according to different actions.
    //   // if(data && data.message=='Cancel') {
    //   //    alert('Cancel was clicked in bottomsheet');
    //   //  } if(data && data.message=='Status') {
    //   //    alert('Change Status was clicked in bottomsheet');
    //   //  }
    //  });
   
    snackBarRef.onAction().subscribe(() => {
      //alert("ondelete");
      this.http.get(this.helper.base_url+'http/delete/parent/'+id,{ headers: this.headers })
      .subscribe(
         
          (data) => {
            let body = JSON.parse(data['_body']);
            //console.log(body)
            if(body.success == 1)
            {
              this.listClick(null) ;
              this.refresh(false,body.message) ;
            }
            else
            {
              this.snackbar.open(body.message, null, {
                duration:5000,
                  extraClasses:'error-snackbar',
                  verticalPosition:'top'
                });
            }
            //this.refresh(false,'Parent deleted Successfully')
          }, //For Success Response
          err => {console.error(err)} //For Error Response
      ); 
    });
   
  }

  add_form(addForm: NgForm){
  let body = new FormData();
  //alert(this.start_dates);
  // console.log(addForm.value.username);
  // console.log(addForm.value.email);
  ///console.log(addForm.value.password);
  //console.log(addForm.value.email);
  //console.log(this.start_dates);
  
  // console.log(addForm.value.ccode);
  // console.log(addForm.value.phone);
  // console.log(this.sgid);
  // console.log( addForm.value.subscription);
  // console.log(addForm.value.city);
  //return;
  body.append('email', addForm.value.email);
  //body.append('password', addForm.value.password);
  //body.append('deviceid', addForm.value.deviceid);
  body.append('username', addForm.value.username);
  //body.append('subscription', addForm.value.subscription);
  body.append('phone', addForm.value.phone);
  body.append('sgid', this.sgid);
  body.append('country_code', addForm.value.ccode);
  body.append('city', addForm.value.city);
  body.append('latitude', "9.931233");
  body.append('longitude', "76.267303");
  body.append('dob',this.start_dates);
   this.http.post(this.helper.base_url+'http/add/parent', body,{ headers: this.headers })
   .subscribe(
     (res) => {
     let  data=JSON.parse(res['_body']);
    if(!data.error){
       this.listClick(null) ;
      this.refresh(false,'User added successfully') ;
    }else{
      //  this.listClick(null) ;
      // this.error_refresh(false,data.message) ;
      this.snackbar.open(data.message, null, {
        duration:5000,
          extraClasses:'error-snackbar',
          verticalPosition:'top'
        });
    }
    
     }, //For Success Response
      err => {console.error(err)} //For Error Response);
   );
 }
  update_form(updateForm: NgForm){
  let body = new FormData();
  //alert(this.start_dates);
  // return;
  //body.append('subscription[]', updateForm.value.subscription);
  body.append('student_id', updateForm.value.student_id);
  body.append('email', updateForm.value.email);
  body.append('username', updateForm.value.username);
  body.append('phone', updateForm.value.phone);
  body.append('country_code', updateForm.value.ccode);
  body.append('city', updateForm.value.city);
  body.append('latitude', "9.931233");
  body.append('longitude', "76.267303");
  body.append('dob',this.start_dates);
  body.append('status',updateForm.value.status);
   this.http.post(this.helper.base_url+'http/update/parent/'+this.parent_id, body,{ headers: this.headers })
   .subscribe(
     (res) => {
     let  data=JSON.parse(res['_body']);
    if(!data.error){
       this.listClick(null) ;
      this.refresh(false,'User updated successfully') ;
    }else{
      this.snackbar.open(data.message, null, {
        duration:5000,
          extraClasses:'error-snackbar',
          verticalPosition:'top'
        });
    }
    
     }, //For Success Response
      err => {console.error(err)} //For Error Response);
   );
 }
  refresh(val=false,msg=''){
  this.snackbar.open(msg, null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["/appusers"]));
  
      
 }
  error_refresh(val=false,msg=''){
  this.snackbar.open(msg, null, {
    duration:5000,
      extraClasses:'error-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["/appusers"]));
  
      
 }
 startEvent(type: string, event: MatDatepickerInputEvent<Date>) {
  this.start_date = event.value;
  let d1 = new Date(Date.parse(this.start_date));
  if(d1.getMonth() <= 9)
  this.indexedmonth = '0'+(d1.getMonth()+1);
  else
  this.indexedmonth = d1.getMonth()+1;
  if(d1.getDate() <= 9)
  this.indexedate = '0'+(d1.getDate());
  else
  this.indexedate = d1.getDate();
  let start_date = d1.getFullYear()+"-"+(this.indexedmonth)+"-"+this.indexedate;
  this.start_dates =start_date;
  //console.log(start_date);
  
    
   
  }
  editdobEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    //alert("end");
    this.editdob = event.value;
    this.editdobdate= event.value;
     //console.log(this.editdob);
     let d1 = new Date(Date.parse(this.editdob));
     if(d1.getMonth() <= 9)
      this.indexedmonth = '0'+d1.getMonth()+1;
     this.editdobdate = d1.getFullYear()+"-"+(this.indexedmonth)+"-"+d1.getDate();
     //console.log(this.editdobdate);
     }
  addPackage(id,studentid)
  {
  // alert(id);
  // alert(studentid);
  }
  addAddress(id,studentid)
  {
    this.router.navigate(["address/"+studentid+"/"+id]);
  }
  unblockClick(parentid)
  {
    //alert(parentid);
    this.router.navigate(["unblock/"+parentid]);
  }
  
 


}



// WEBPACK FOOTER //
// ./src/app/parents/parents.component.ts